// Mezura ölçüleri yorumları (2026-10-05). Mobil karşılığı:
// Pupill-Mobil/utils/bodyCircumference.ts (aynı kurallar, elle senkron).
// Eşikler DSÖ'nün yaygın kullanılan kesim noktalarıdır; tanı amaçlı değildir.

export const CIRCUMFERENCE_KEYS = [
  { key: "waist", label: "Bel" },
  { key: "hip", label: "Kalça" },
  { key: "chest", label: "Göğüs" },
  { key: "arm", label: "Kol" },
  { key: "thigh", label: "Bacak" },
  { key: "neck", label: "Boyun" },
];

const isFemale = (g) => String(g || "").toLocaleLowerCase("tr").startsWith("k");
const isMale = (g) => String(g || "").toLocaleLowerCase("tr").startsWith("e");
const round = (v, d = 2) => Math.round(v * 10 ** d) / 10 ** d;

/** Bel çevresi riski: "normal" | "increased" | "high" | null (cinsiyet yoksa). */
export function waistRisk(waist, gender) {
  const w = Number(waist);
  if (!(w > 0)) return null;
  if (isFemale(gender)) return w >= 88 ? "high" : w >= 80 ? "increased" : "normal";
  if (isMale(gender)) return w >= 102 ? "high" : w >= 94 ? "increased" : "normal";
  return null;
}

/** Bel/kalça oranı ve riski. */
export function waistHipRatio(waist, hip, gender) {
  const w = Number(waist);
  const h = Number(hip);
  if (!(w > 0) || !(h > 0)) return null;
  const ratio = round(w / h);
  const limit = isFemale(gender) ? 0.85 : isMale(gender) ? 0.9 : null;
  return { ratio, risk: limit == null ? null : ratio >= limit ? "high" : "normal" };
}

/** Bel/boy oranı ve riski (0,5 ve üstü riskli, 0,6 ve üstü yüksek). */
export function waistHeightRatio(waist, heightCm) {
  const w = Number(waist);
  const h = Number(heightCm);
  if (!(w > 0) || !(h > 0)) return null;
  const ratio = round(w / h);
  return { ratio, risk: ratio >= 0.6 ? "high" : ratio >= 0.5 ? "increased" : "normal" };
}

export const RISK_LABEL = { normal: "Normal", increased: "Artmış risk", high: "Yüksek risk" };

/**
 * Ölçüm kayıtlarından her alan için başlangıç ve son değer.
 * `since` (YYYY-MM-DD veya tarih) verilirse başlangıç o tarihteki/sonraki ilk
 * ölçüm; yoksa ilk ölçüm. Kayıtlar Measurement dokümanlarıdır.
 */
export function circumferenceProgress(records, since) {
  const sinceTime = since ? new Date(since).getTime() : null;
  const list = (records || [])
    .filter((r) => r.metricType === "body_circumference")
    .sort((a, b) => new Date(a.takenAt) - new Date(b.takenAt));
  const out = {};
  for (const { key } of CIRCUMFERENCE_KEYS) {
    const points = list
      .map((r) => ({ at: r.takenAt, value: (r.values || []).find((v) => v.key === key)?.value }))
      .filter((p) => Number(p.value) > 0);
    if (!points.length) continue;
    const baseCandidates = sinceTime ? points.filter((p) => new Date(p.at).getTime() >= sinceTime) : points;
    const base = baseCandidates[0] || points[0];
    const last = points[points.length - 1];
    out[key] = {
      latest: Number(last.value),
      latestAt: last.at,
      baseline: Number(base.value),
      baselineAt: base.at,
      change: round(Number(last.value) - Number(base.value), 1),
      count: points.length,
    };
  }
  return out;
}
